import React from 'react';
import { motion } from 'framer-motion';
import { FaArrowRight, FaCheckCircle, FaChartLine } from 'react-icons/fa';

const CTASection = () => {
  return (
    <section className="relative py-12 overflow-hidden bg-white">
      {/* Background Animated Blobs & Market Assets */}
      <div className="absolute inset-0 z-0 overflow-hidden">
        {/* Soft Background Blobs */}
        <motion.div 
          animate={{ x: [0, 40, 0], y: [0, -30, 0] }}
          transition={{ duration: 15, repeat: Infinity, ease: "easeInOut" }}
          className="absolute top-0 left-1/4 w-72 h-72 bg-blue-50 rounded-full blur-3xl opacity-70"
        />
        <motion.div 
          animate={{ x: [0, -20, 0], y: [0, 40, 0] }}
          transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
          className="absolute bottom-0 right-1/4 w-96 h-96 bg-indigo-50 rounded-full blur-3xl opacity-70"
        />

        {/* Floating Animated Candlestick / Graph Lines */}
        {[1, 2, 3].map((i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 100 }}
            animate={{ 
              opacity: [0, 0.15, 0], 
              y: [-20, -150],
              x: i * 50 
            }}
            transition={{ 
              duration: 8, 
              repeat: Infinity, 
              delay: i * 2,
              ease: "linear" 
            }}
            className="absolute hidden md:block text-blue-200"
            style={{ left: `${20 + (i * 25)}%`, bottom: '0' }}
          >
            <FaChartLine size={80 + (i * 20)} />
          </motion.div>
        ))}
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-r from-blue-700 via-indigo-700 to-blue-800 rounded-2xl p-6 md:p-10 shadow-2xl relative overflow-hidden border border-white/10">
          
          {/* Subtle Inner Rotating Stock Pulse */}
          <motion.div 
            animate={{ scale: [1, 1.1, 1], opacity: [0.05, 0.1, 0.05] }}
            transition={{ duration: 4, repeat: Infinity }}
            className="absolute -right-20 -top-20 w-80 h-80 bg-white rounded-full"
          />

          <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
            
            {/* Left Side: Stock Market Content */}
            <div className="text-left max-w-xl">
              <h2 className="text-2xl md:text-3xl font-extrabold text-white mb-3 tracking-tight">
                Unlock Real-Time Market Mastery
              </h2>
              <p className="text-blue-100/80 mb-4 text-sm md:text-base">
                Join thousands of traders using professional-grade tools to navigate the markets.
              </p>
              <div className="flex flex-wrap gap-x-6 gap-y-2">
                {['Live Market Access', 'Advanced Analysis', 'Expert Insights'].map((item, i) => (
                  <div key={i} className="flex items-center gap-2 text-white text-sm font-semibold">
                    <FaCheckCircle className="text-green-400" />
                    {item}
                  </div>
                ))}
              </div>
            </div>

            {/* Right Side: Primary Link Button */}
            <div className="shrink-0 w-full sm:w-auto">
              <motion.a
                href="https://www.marketmaestroo.com/"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.05, boxShadow: "0px 0px 20px rgba(255,255,255,0.3)" }}
                whileTap={{ scale: 0.95 }}
                className="inline-flex w-full sm:w-auto px-10 py-4 bg-white text-blue-700 font-bold rounded-xl shadow-lg hover:bg-blue-50 transition-all items-center justify-center gap-3 text-lg"
              >
                Get Started Now <FaArrowRight className="text-sm" />
              </motion.a>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;